import TotalRevenueComponent from "./TotalRevenueComponent";

export default TotalRevenueComponent;
